import {connect} from 'react-redux';
import ContentHubComponent from './ContentHub';
import determineIfMobile from '@homeaway/react-determine-if-mobile';
import {TABLET_BREAKPOINT} from '../../utils/constants';

function mapStateToProps({modules: {contentHubData}}) {
    return {
        contentHubData,
    };
}

export const ContentHub = connect(mapStateToProps)(
    determineIfMobile(ContentHubComponent, TABLET_BREAKPOINT)
);

ContentHub.displayName = 'ContentHub';

export default ContentHub;
